import { memo, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useForm from 'antd/lib/form/hooks/useForm';

import WithSettingsForm from 'components/Settings/hocs/WithSettingsForm';
import TradingPoliciesGeneral from 'components/Settings/TradingPoliciesTab/TradingPoliciesGeneral';
import TradingPoliciesMAP from 'components/Settings/TradingPoliciesTab/TradingPoliciesMAP';
import TradingPoliciesMarketplaces from 'components/Settings/TradingPoliciesTab/TradingPoliciesMarketplaces';
import SettingsSkeleton from 'components/Skeletons/Settings/SettingsSkeleton';
import { selectPolicySettings } from 'store/selectors/settingsSelectors';
import { getSettingsByKeyAction, updateSettingsByKeyAction } from 'store/actions/settingsActions';
import { ESettingsKey } from 'store/reducers/settingsReducer/settingsTypes';
import { useTypedSelector } from 'hooks/useTypedSelector';
import { SettingsTabPaths } from 'components/Settings/constants';
import { EPoliciesFields } from 'types/settings/enums';

const TradingPoliciesTab = () => {
  const dispatch = useDispatch();
  const { isUpdated, isLoading, ...policy } = useTypedSelector(selectPolicySettings);
  const [form] = useForm();
  const initialValues = {
    ...policy,
    [EPoliciesFields.Discount]: policy[EPoliciesFields.Discount] || 20,
    [EPoliciesFields.HasDiscount]: policy[EPoliciesFields.HasDiscount] || false,
    [EPoliciesFields.MapPercent]: policy[EPoliciesFields.MapPercent] || 0,
  };

  const handleSubmit = async() => {
    const values = form.getFieldsValue();

    await dispatch(updateSettingsByKeyAction(values, ESettingsKey.PolicySettings));
  };

  useEffect(() => {
    !isUpdated && dispatch(getSettingsByKeyAction(ESettingsKey.PolicySettings));
  }, []);

  if (isLoading) {
    return <SettingsSkeleton />;
  }

  return (
    <WithSettingsForm
      form={form}
      initialValues={initialValues}
      rootPath={SettingsTabPaths.TradingPolicies}
      onSubmit={handleSubmit}
    >
      <TradingPoliciesGeneral />
      <TradingPoliciesMAP {...form} />
      <TradingPoliciesMarketplaces />
    </WithSettingsForm>
  );
};

export default memo(TradingPoliciesTab);
